import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  // F02: min 44px mobile (Touch), 36px ab 761px (min-[761px]:). Langer Text darf
  // umbrechen, damit er nie den Viewport überläuft. Native disabled-Buttons
  // bleiben via disabled:pointer-events-none + disabled:opacity-50 deaktiviert.
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        // 44px bis 760px, 36px ab 761px. Text wrappt statt zu overflowen.
        default:
          "min-h-11 min-[761px]:min-h-9 px-4 text-center [white-space:normal] leading-4",
        sm: "min-h-11 min-w-11 min-[761px]:min-h-9 min-[761px]:min-w-9 rounded-md px-3 [white-space:normal] leading-4",
        lg: "min-h-11 min-[761px]:min-h-10 rounded-md px-8 [white-space:normal] leading-4",
        icon: "h-11 w-11 min-[761px]:h-9 min-[761px]:w-9 min-w-11 min-[761px]:min-w-9 shrink-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }
